import PaymentImage from '../../public/images/Payment.png';
import RestartImage from '../../public/images/Restart.png';
import PodsImage from '../../public/images/Pods.png';

const carousels = [
    {
        title: 'Ask me anything',
        img: 'Payment',
        imgURL: PaymentImage,
        description:
            'I’m an expert on a range of topics related to your Xfinity services. You can describe any issue you’re having, or just ask a question, like “How do I pay my bill?” If for some reason I can’t give you the answer, I’ll get you an agent who can.',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'Ask',
        linkText: 'Ask Xfinity',
    },
    {
        title: 'Service problems?',
        img: 'Restart',
        imgURL: RestartImage,
        description:
            'If you need help fixing an issue quickly, just tell me “Troubleshoot a service” and I’ll guide you from there. Quick and easy. No need to wait on a phone call or hunt for answers online.\n',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'Start',
        linkText: 'Start troubleshooting',
    },
    {
        title: 'I work with your Xfinity services',
        img: 'Pods',
        imgURL: PodsImage,
        description:
            'My job is to show up for you whenever and wherever you need assistance with any of your Xfinity products or services. I can help with a variety of tasks, from recording your favorite shows on your X1 DVR to updating you on your package delivery.',
        link: 'https://www.xfinity.com/xfinityassistant',
        linkID: 'DoYou',
        linkText: 'Do you need help with anything now?',
    },
];

export default carousels;
